import { ThemeOptions } from "@mui/material";

export const darkTheme: ThemeOptions = {
  cssVariables: true,
  palette: {
    mode: "dark",
  },
  shape: {
    borderRadius: 3,
  },
  typography: {
    h1: {
      fontSize: "1rem",
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 400,
    },
    h3: {
      fontSize: "2rem",
      fontWeight: 400,
    },
  },
};
